import React, { useState, useEffect } from 'react';
import { Send } from 'lucide-react';
import { handleFormSubmission, getCountryInfo } from '../services/api';

const countryCodes = [
  { code: '+1', country: 'US', flag: '🇺🇸', length: 10 },
  { code: '+1', country: 'CA', flag: '🇨🇦', length: 10 },
  { code: '+44', country: 'GB', flag: '🇬🇧', length: 10 },
  { code: '+91', country: 'IN', flag: '🇮🇳', length: 10 },
  { code: '+61', country: 'AU', flag: '🇦🇺', length: 9 },
  { code: '+92', country: 'PK', flag: '🇵🇰', length: 10 },
  { code: '+86', country: 'CN', flag: '🇨🇳', length: 11 },
  { code: '+81', country: 'JP', flag: '🇯🇵', length: 10 },
  { code: '+49', country: 'DE', flag: '🇩🇪', length: 10 },
  { code: '+33', country: 'FR', flag: '🇫🇷', length: 9 },
  { code: '+39', country: 'IT', flag: '🇮🇹', length: 10 },
  { code: '+34', country: 'ES', flag: '🇪🇸', length: 9 },
  { code: '+52', country: 'MX', flag: '🇲🇽', length: 10 },
  { code: '+55', country: 'BR', flag: '🇧🇷', length: 11 },
  { code: '+27', country: 'ZA', flag: '🇿🇦', length: 9 },
  { code: '+971', country: 'AE', flag: '🇦🇪', length: 9 },
  { code: '+31', country: 'NL', flag: '🇳🇱', length: 9 },
  { code: '+966', country: 'SA', flag: '🇸🇦', length: 9 },
  { code: '+20', country: 'EG', flag: '🇪🇬', length: 10 },
  { code: '+234', country: 'NG', flag: '🇳🇬', length: 10 },
  { code: '+254', country: 'KE', flag: '🇰🇪', length: 10 },
  { code: '+7', country: 'RU', flag: '🇷🇺', length: 10 },
  { code: '+90', country: 'TR', flag: '🇹🇷', length: 10 },
  { code: '+82', country: 'KR', flag: '🇰🇷', length: 10 },
  { code: '+66', country: 'TH', flag: '🇹🇭', length: 9 },
  { code: '+60', country: 'MY', flag: '🇲🇾', length: 9 },
  { code: '+65', country: 'SG', flag: '🇸🇬', length: 8 },
  { code: '+63', country: 'PH', flag: '🇵🇭', length: 10 },
  { code: '+62', country: 'ID', flag: '🇮🇩', length: 10 },
  { code: '+84', country: 'VN', flag: '🇻🇳', length: 9 },
  { code: '+880', country: 'BD', flag: '🇧🇩', length: 10 },
  { code: '+32', country: 'BE', flag: '🇧🇪', length: 9 },
  { code: '+46', country: 'SE', flag: '🇸🇪', length: 9 },
  { code: '+47', country: 'NO', flag: '🇳🇴', length: 8 },
  { code: '+45', country: 'DK', flag: '🇩🇰', length: 8 },
  { code: '+358', country: 'FI', flag: '🇫🇮', length: 9 },
  { code: '+48', country: 'PL', flag: '🇵🇱', length: 9 },
  { code: '+30', country: 'GR', flag: '🇬🇷', length: 10 },
  { code: '+351', country: 'PT', flag: '🇵🇹', length: 9 },
  { code: '+420', country: 'CZ', flag: '🇨🇿', length: 9 },
  { code: '+43', country: 'AT', flag: '🇦🇹', length: 10 },
  { code: '+41', country: 'CH', flag: '🇨🇭', length: 9 },
  { code: '+353', country: 'IE', flag: '🇮🇪', length: 9 },
  { code: '+64', country: 'NZ', flag: '🇳🇿', length: 9 },
  { code: '+54', country: 'AR', flag: '🇦🇷', length: 10 },
  { code: '+56', country: 'CL', flag: '🇨🇱', length: 9 },
  { code: '+57', country: 'CO', flag: '🇨🇴', length: 10 },
  { code: '+51', country: 'PE', flag: '🇵🇪', length: 9 },
  { code: '+58', country: 'VE', flag: '🇻🇪', length: 10 },
  { code: '+972', country: 'IL', flag: '🇮🇱', length: 9 }
];

const inputClass = (err) =>
  `w-full px-4 py-3 border ${err ? 'border-red-500' : 'border-gray-300'} rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#168356] focus:border-transparent`;

const ServiceHeroForm = ({ title, buttonText, serviceType = 'registration' }) => {
  const [formData, setFormData] = useState({
    name: '',
    countryCode: '+1',
    phone: '',
    email: '',
    message: '',
    serviceType,
    tmSignUpType: 1
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');

  useEffect(() => {
    let isMounted = true;
    getCountryInfo()
      .then((info) => {
        if (isMounted && info?.dialCode) setFormData((prev) => ({ ...prev, countryCode: info.dialCode }));
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    const cleanPhone = formData.phone.replace(/\D/g, '');
    const country = countryCodes.find((c) => c.code === formData.countryCode);
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    else if (cleanPhone.length < 7 || (country ? cleanPhone.length !== country.length : cleanPhone.length > 15)) {
      newErrors.phone = country ? `Phone must be ${country.length} digits` : 'Invalid phone number';
    }
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Invalid email format';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setIsSubmitting(true);
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-CONVERSION_ID/LABEL', event_category: formData.serviceType });
    }
    if (window.fbq) {
      window.fbq('track', 'Lead', { content_name: formData.serviceType });
    }
    await handleFormSubmission(
      formData,
      () => {
        setIsSubmitted(true);
        setIsSubmitting(false);
      },
      (error) => {
        setApiError(error);
        setIsSubmitting(false);
      }
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto lg:ml-auto p-8 text-left">
      {isSubmitted ? (
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Send className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">Thank You!</h3>
          <p className="text-gray-600">We'll contact you within 24 hours.</p>
        </div>
      ) : (
        <>
          <div className="text-center mb-6">
            <div className="w-12 h-12 bg-[#168356] rounded-full flex items-center justify-center mx-auto mb-4">
              <Send className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600">Fill out the form below and our expert will contact you within 24 hours</p>
          </div>

          {apiError && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
              <p className="text-sm">{apiError}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input type="text" name="name" value={formData.name} onChange={handleChange} className={inputClass(errors.name)} placeholder="Your Name *" />
              {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
            </div>

            <div>
              <div className="flex gap-2">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={handleChange}
                  className="w-24 px-2 py-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#168356] focus:border-transparent text-sm"
                >
                  {countryCodes.map((country, idx) => (
                    <option key={idx} value={country.code}>
                      {country.flag} {country.code}
                    </option>
                  ))}
                </select>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className={`flex-1 ${inputClass(errors.phone)}`} placeholder="Phone Number *" />
              </div>
              {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
            </div>

            <div>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className={inputClass(errors.email)} placeholder="Your Email *" />
              {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
            </div>

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#168356] focus:border-transparent resize-none"
              placeholder="Tell us about your brand or questions (Optional)"
            />

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#d29b00] hover:bg-[#a87b00] text-white font-bold px-6 py-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                'Submitting...'
              ) : (
                <>
                  <Send className="w-5 h-5" />
                  {buttonText}
                </>
              )}
            </button>

            <p className="text-center text-gray-500 text-xs">No credit card required • Free consultation</p>
          </form>
        </>
      )}
    </div>
  );
};

export default ServiceHeroForm;
